import { i18n } from "@lingui/core";
import { AdditionalLicense } from "../../types/License";

export const validUntilMsg = ({
  license,
  isTeacher,
  isClasswizCalcAppValid,
}: {
  license?: AdditionalLicense;
  isTeacher?: boolean;
  isClasswizCalcAppValid?: boolean;
}) => {
  if (isTeacher) {
    return i18n._({
      id: "license.status.permanently",
    });
  } else if (
    isClasswizCalcAppValid &&
    license &&
    new Date(license?.validUntil) >= new Date()
  ) {
    return i18n._({
      id: "license.status.valid-through",
    });
  } else {
    return i18n._({
      id: "Keine Lizenz gekauft",
    });
  }
};
